'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Sizing and Rhythm
 */
var rhythm = exports.rhythm = function rhythm() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rem';
  var basis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1.5;
  return Array.isArray(value) ? value.map(function (v) {
    return '' + basis * v + unit;
  }).join(' ') : '' + basis * value + unit;
};

var scale = exports.scale = function scale() {
  var exponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.2;
  return Math.pow(scale, exponent) + 'rem';
};

/**
 * Colors
 */
var colors = exports.colors = {
  light: '#fff',
  dark: '#000',
  grey: '#7a898f',
  lightGrey: '#aec0c6',
  paleGrey: '#ebf1f3',
  primary: '#1bab6b',
  secondary: '#ad29b6',
  tertiary: '#203a44',
  shade: 'rgba(0, 0, 0, 0.125)',
  tint: 'rgba(255, 255, 255, 0.25)',
  transparent: 'transparent',
  inherit: 'inherit',
  facebook: '#3b5999',
  twitter: '#55acee',
  instagram: '#e4405f',
  youtube: '#cd201f',
  linkedin: '#0084bf',
  google: '#dd4b39',
  vimeo: '#1ab7ea',
  fitbit: '#00b0b9',
  mapmyfitness: '#004a8d',
  strava: '#fc4c02',
  twitch: '#6701B3',
  slack: '#4a154b',
  whatsapp: '#25d366',
  pinterest: '#bd081c',
  messenger: '#0084ff',
  reddit: '#ff4500',
  danger: '#d9534f',
  success: '#5cb85c',
  blackbaud: '#8cbe4f',
  everydayhero: '#1bab6b',
  justgiving: '#ad29b6'

  /**
   * Fonts
   */
};var fonts = exports.fonts = {
  head: '"Open Sans", sans-serif',
  body: '"Open Sans", sans-serif'
};

var measures = exports.measures = {
  medium: 1.5
};

var treatments = exports.treatments = {
  head: {
    fontFamily: fonts.head,
    fontWeight: 700
  },
  body: {
    fontFamily: fonts.body
  },
  button: {
    fontFamily: fonts.head,
    textTransform: 'uppercase',
    fontWeight: 700
  },
  input: {
    fontFamily: fonts.body
  },
  container: {
    maxWidth: rhythm(40)
  }

  /**
   * Default background styles
   */
};var background = exports.background = function background(url) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cover';
  return {
    backgroundImage: !!url && 'url(\'' + url + '\')',
    backgroundSize: size,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center'
  };
};

/**
 * Borders and Edges
 */
var shadows = exports.shadows = {
  none: 'none',
  light: '0 0 15px rgba(0, 0, 0, 0.125)'
};

var radiuses = exports.radiuses = {
  none: 0,
  small: 0.1,
  medium: 0.25,
  large: 50

  /**
   * Media Queries
   */
};var breakpoints = exports.breakpoints = {
  xs: '24rem',
  sm: '36rem',
  md: '48rem',
  lg: '60rem',
  xl: '72rem'
};

var mediaQuery = exports.mediaQuery = function mediaQuery() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'sm';
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'min-width';
  return '@media (' + query + ': ' + breakpoints[size] + ')';
};

/**
 * Effects, Animations, Transitions, Utils
 */
var transitions = exports.transitions = {
  easeOut: 'ease-out .25s'
};

var utils = exports.utils = {
  fullSize: {
    position: 'absolute',
    content: '""',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
};

var effects = exports.effects = {
  none: {},
  shade: {
    position: 'relative',
    '&:before': _extends({
      transition: transitions.easeOut
    }, utils.fullSize, {
      backgroundColor: colors.shade,
      opacity: 0
    }),
    '&:hover:before': {
      opacity: 1
    }
  },
  tint: {
    position: 'relative',
    '&:before': _extends({
      transition: transitions.easeOut
    }, utils.fullSize, {
      backgroundColor: colors.tint,
      opacity: 0
    }),
    '&:hover:before': {
      opacity: 1
    }
  },
  grow: {
    transition: transitions.easeOut,
    backfaceVisibility: 'hidden',
    '&:hover': {
      transform: 'scale(1.1)'
    }
  },
  shrink: {
    transition: transitions.easeOut,
    backfaceVisibility: 'hidden',
    '&:hover': {
      transform: 'scale(0.925)'
    }
  }

  /**
   * Flexbox justifyContent style polyfill
   */
};var justifyContent = exports.justifyContent = function justifyContent(value) {
  var flexPack = {
    'flex-start': 'start',
    'flex-end': 'end',
    'space-between': 'justify',
    'space-around': 'distribute',
    center: 'center'
  };

  return {
    justifyContent: value,
    flexPack: flexPack[value]
  };
};

/**
 * Spacing - for handling spacing objects i.e. padding/margin props
 * e.g. { x: 1, y: 2 } or { l: 1, t: 2 } or 5 etc.
 */

var calculateSpacing = exports.calculateSpacing = function calculateSpacing(spacing) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'padding';
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var defaultOptions = {
    multiplier: 1
  };

  var options = _extends({}, defaultOptions, args);

  switch (typeof spacing === 'undefined' ? 'undefined' : _typeof(spacing)) {
    case 'number':
      return _defineProperty({}, type, rhythm(spacing * options.multiplier, options.unit, options.basis));
    case 'object':
      return Object.keys(spacing).reduce(function (styles, direction) {
        return _extends({}, styles, spacingDirection(direction, spacing[direction], type, options));
      }, {});
    default:
      return {};
  }
};

var spacingDirection = function spacingDirection(direction, space, type, options) {
  var map = {
    t: ['Top'],
    r: ['Right'],
    b: ['Bottom'],
    l: ['Left'],
    x: ['Left', 'Right'],
    y: ['Top', 'Bottom']
  };

  var fields = map[direction] || [];

  var styles = fields.reduce(function (styles, property) {
    return _extends({}, styles, _defineProperty({}, '' + type + property, rhythm(space * options.multiplier, options.unit, options.basis)));
  }, {});

  return styles;
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/lib/traits/index.js
// module id = 233
// module chunks = 0